/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const TRANSLATION_LANGUAGES = [
  /** 1. Mandarin - 1.1 billion speakers */
  'zh',
  /** 2. Hindi - 600 million speakers */
  'hi',
  /** 3. Spanish - 560 million speakers */
  'es',
  /** 4. French - 270 million speakers */
  'fr',
  /** 5. Arabic - 270 million speakers */
  'ar',
  /** 6. Bengali - 270 million speakers */
  'bn',
  /** 7. Portuguese - 260 million speakers */
  'pt',
  /** 8. Russian - 250 million speakers */
  'ru',
  /** 9. Urdu - 230 million speakers */
  'ur',
  /** 10. German - 135 million speakers */
  'de',
  /** 22. Persian - 80 million speakers */
  'fa',
  /** 23. Italian - 68 million speakers */
  'it',
] as const;

export const translationLanguageSchema = z.enum(TRANSLATION_LANGUAGES);

export type ITranslationLanguage = z.infer<typeof translationLanguageSchema>;
